import { render } from "./Index.vue?vue&type=template&id=0f3f2940&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=0f3f2940&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0f3f2940"

export default script